import { screenSizes } from 'chime-ui/system/media';

function detectMobileScreen() {
  const userAgent = window.navigator.userAgent;
  const userAgentMatchResult = userAgent.match(
    /Android|webOS|iPhone|iPod|BlackBerry|BB|IEMobile|Windows Phone|Silk|Opera Mini|Mobile/i
  );

  // Not using useMedia() because we are only interested in checking this once
  const isMobileScreenSize = window.matchMedia(
    `(max-width: ${screenSizes.tablet - 1}px)`
  ).matches;
  const isMobileScreen = userAgentMatchResult && isMobileScreenSize;

  return !!isMobileScreen;
}

export default detectMobileScreen;
